import React from 'react';

export function Icon({ name, ...rest }) {
  const Component = icons[name];

  return (
    <Component {...rest}/>
  );
};

const SVG = ({ children, width, ...restProps }) => {
  const widthPx = width + 'px';

  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width={widthPx}
         {...restProps}
         className="icon">{children}</svg>
  )

};

const Manage = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 27.54 17.46">
      <path className="cls-2"
            d="M18.75,10a15.4,15.4,0,0,1,3.6.48,12.15,12.15,0,0,1,3.57,1.47,3,3,0,0,1,1.62,2.43v3.12H20V14.34A5.2,5.2,0,0,0,17.58,10,8.77,8.77,0,0,1,18.75,10Zm-10,0a15,15,0,0,1,3.57.48,11.71,11.71,0,0,1,3.54,1.47,3,3,0,0,1,1.62,2.43v3.12H0V14.34a3,3,0,0,1,1.62-2.43,12.15,12.15,0,0,1,3.57-1.47A15.4,15.4,0,0,1,8.79,10Zm0-2.46A3.62,3.62,0,0,1,6.93,7,3.8,3.8,0,0,1,5.55,5.61a3.65,3.65,0,0,1,0-3.72A3.8,3.8,0,0,1,6.93.51,3.62,3.62,0,0,1,8.79,0a3.56,3.56,0,0,1,1.85.51A3.77,3.77,0,0,1,12,1.88a3.66,3.66,0,0,1,.5,1.87A3.7,3.7,0,0,1,12,5.63,3.75,3.75,0,0,1,10.64,7,3.53,3.53,0,0,1,8.79,7.5Zm10,0A3.62,3.62,0,0,1,16.89,7a3.8,3.8,0,0,1-1.38-1.38,3.65,3.65,0,0,1,0-3.72A3.8,3.8,0,0,1,16.89.51a3.65,3.65,0,0,1,3.72,0A3.8,3.8,0,0,1,22,1.89a3.65,3.65,0,0,1,0,3.72A3.8,3.8,0,0,1,20.61,7,3.62,3.62,0,0,1,18.75,7.5Z"/>
    </SVG>
  )
};

const Schedule = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 22.5 25.02">
      <path className="cls-2"
            d="M13.77,16.29v2.46H5V16.29ZM20,22.5V8.79H2.52V22.5Zm0-20a2.42,2.42,0,0,1,1.77.75A2.42,2.42,0,0,1,22.5,5V22.5A2.56,2.56,0,0,1,20,25H2.52a2.42,2.42,0,0,1-1.79-.75A2.44,2.44,0,0,1,0,22.5V5A2.44,2.44,0,0,1,.73,3.27a2.4,2.4,0,0,1,1.79-.75H3.75V0H6.27V2.52h10V0h2.52V2.52Zm-2.46,8.73v2.52H5V11.25Z"/>
    </SVG>
  )
};

const Boards = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 22.5 22.51">
      <path className="cls-1"
            d="M3.24,6.75A2.47,2.47,0,0,1,2.52,5a2.37,2.37,0,0,1,.72-1.74A2.37,2.37,0,0,1,5,2.52a2.47,2.47,0,0,1,1.77.72A2.32,2.32,0,0,1,7.5,5a2.42,2.42,0,0,1-.75,1.77A2.42,2.42,0,0,1,5,7.5,2.32,2.32,0,0,1,3.24,6.75ZM1.23,0A1.19,1.19,0,0,0,.36.36,1.19,1.19,0,0,0,0,1.23v7.5a1.29,1.29,0,0,0,.36.9,1.14,1.14,0,0,0,.87.39h20a1.14,1.14,0,0,0,.87-.39,1.29,1.29,0,0,0,.36-.9V1.23a1.19,1.19,0,0,0-.36-.87A1.19,1.19,0,0,0,21.27,0Zm2,19.26a2.37,2.37,0,0,1-.72-1.74,2.47,2.47,0,0,1,.72-1.77A2.32,2.32,0,0,1,5,15a2.42,2.42,0,0,1,1.77.75,2.42,2.42,0,0,1,.75,1.77,2.32,2.32,0,0,1-.75,1.74A2.47,2.47,0,0,1,5,20,2.37,2.37,0,0,1,3.24,19.26Zm-2-6.78a1.13,1.13,0,0,0-.87.38,1.28,1.28,0,0,0-.36.92v7.5a1.19,1.19,0,0,0,.36.87,1.19,1.19,0,0,0,.87.36h20a1.23,1.23,0,0,0,1.23-1.23v-7.5a1.28,1.28,0,0,0-.36-.92,1.17,1.17,0,0,0-.87-.38Z"/>
    </SVG>
  )
};

const Reports = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 22.5 22.5">
      <path
        d="M15,17.52v-5h2.52v5Zm-5,0V5h2.46V17.52Zm-5,0V8.73H7.5v8.79ZM2.52,0A2.42,2.42,0,0,0,.75.75,2.42,2.42,0,0,0,0,2.52V20a2.42,2.42,0,0,0,.75,1.77,2.42,2.42,0,0,0,1.77.75H20A2.56,2.56,0,0,0,22.5,20V2.52A2.42,2.42,0,0,0,21.75.75,2.42,2.42,0,0,0,20,0Z"/>
    </SVG>
  )
};

const Wheel = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 24.29 24.96">
      <path
        d="M10,16.26a4.57,4.57,0,0,1-1.6-1.61,4.16,4.16,0,0,1-.6-2.18,4.25,4.25,0,0,1,.6-2.19A4.52,4.52,0,0,1,10,8.66a4.19,4.19,0,0,1,2.18-.6,4.25,4.25,0,0,1,2.19.6A4.49,4.49,0,0,1,16,10.28a4.25,4.25,0,0,1,.6,2.19,4.19,4.19,0,0,1-.6,2.18,4.54,4.54,0,0,1-1.62,1.61,4.25,4.25,0,0,1-2.19.6A4.19,4.19,0,0,1,10,16.26Zm11.57-3.78a9.38,9.38,0,0,0-.06-1.23l2.61-2a.58.58,0,0,0,.21-.39.71.71,0,0,0-.09-.45L21.68,4.05a.57.57,0,0,0-.31-.27.65.65,0,0,0-.43,0L17.85,5a7.79,7.79,0,0,0-2.13-1.23L15.27.54a.76.76,0,0,0-.22-.39A.55.55,0,0,0,14.68,0h-5a.51.51,0,0,0-.37.15.62.62,0,0,0-.2.39L8.59,3.81A9.68,9.68,0,0,0,6.49,5L3.37,3.81a.53.53,0,0,0-.75.24L.1,8.37A.71.71,0,0,0,0,8.82a.58.58,0,0,0,.21.39l2.64,2a9.38,9.38,0,0,0-.06,1.23,9.38,9.38,0,0,0,.06,1.23l-2.64,2a.58.58,0,0,0-.21.39.71.71,0,0,0,.09.45l2.52,4.32a.53.53,0,0,0,.75.24l3.12-1.23a7.55,7.55,0,0,0,2.1,1.23l.48,3.27a.57.57,0,0,0,.2.39.55.55,0,0,0,.37.15h5a.53.53,0,0,0,.37-.15.76.76,0,0,0,.22-.39l.45-3.27a9.81,9.81,0,0,0,2.13-1.23l3.09,1.23a.65.65,0,0,0,.43,0,.51.51,0,0,0,.31-.27l2.52-4.32a.71.71,0,0,0,.09-.45.58.58,0,0,0-.21-.39l-2.61-2A9.38,9.38,0,0,0,21.53,12.48Z"/>
    </SVG>
  )
};

const Magnifier = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 14.58 14.58">
      <path
        d="M3.56,8.67A3.91,3.91,0,0,1,2.19,7.3a3.61,3.61,0,0,1-.51-1.88,3.61,3.61,0,0,1,.51-1.88A3.8,3.8,0,0,1,3.56,2.18a3.78,3.78,0,0,1,3.76,0A3.72,3.72,0,0,1,9.18,5.42a3.7,3.7,0,0,1-.5,1.88A3.8,3.8,0,0,1,7.32,8.67a3.61,3.61,0,0,1-1.88.51A3.61,3.61,0,0,1,3.56,8.67Zm6.2.51-.22-.24a5,5,0,0,0,1-1.61,5.56,5.56,0,0,0,.33-1.91,5.41,5.41,0,0,0-.71-2.72,5.26,5.26,0,0,0-1.93-2A5.34,5.34,0,0,0,5.44,0,5.36,5.36,0,0,0,2.71.72a5.42,5.42,0,0,0-2,2A5.27,5.27,0,0,0,0,5.42,5.36,5.36,0,0,0,2.71,10.1a5.36,5.36,0,0,0,2.73.72,5.53,5.53,0,0,0,1.89-.33,5,5,0,0,0,1.61-1l.24.22v.66l4.14,4.16,1.26-1.26L10.44,9.18Z"/>
    </SVG>
  )
};

const ChevronDown = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 15 9.27">
      <path
        d="M0,1.77l7.5,7.5L15,1.77,13.23,0,7.5,5.76,1.77,0Z"/>
    </SVG>
  )
};

const MoreVert = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 4 16">
      <path
        d="M2,4A2,2,0,1,0,0,2,2,2,0,0,0,2,4ZM2,6A2,2,0,1,0,4,8,2,2,0,0,0,2,6Zm0,6a2,2,0,1,0,2,2A2,2,0,0,0,2,12Z"/>
    </SVG>
  )
};

const Plus = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 11.64 11.64">
      <path
        d="M11.64,5h-5V0H5V5H0V6.64H5v5H6.64v-5h5Z"/>
    </SVG>
  )
};

const CircleWithPlus = ({ fill, width, ...restProps }) => {
  let style = {
    display: 'flex',
    justifyContent: 'center',
    width: width * 1.7 + 'px',
    height: width * 1.7 + 'px',
    borderRadius: (width * 1.7) / 2 + 1 + 'px',
    border: `1px solid ${fill}`,
  };

  return (
    <div style={style}>
      <Plus fill={fill} width={width} {...restProps} />
    </div>
  )
};

const Person = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 12.53 12.51">
      <path
        d="M6.27,7.83a10.54,10.54,0,0,1,2.55.34,8,8,0,0,1,2.55,1.05,2.14,2.14,0,0,1,1.16,1.72v1.57H0V10.94A2.13,2.13,0,0,1,1.16,9.22,8,8,0,0,1,3.71,8.17a11.07,11.07,0,0,1,2.55-.34Zm0-1.57a3,3,0,0,1-1.56-.42A3.14,3.14,0,0,1,3.58,4.71a3,3,0,0,1-.42-1.56,3.14,3.14,0,0,1,.42-1.58A3.12,3.12,0,0,1,4.71.42,3,3,0,0,1,6.27,0,3,3,0,0,1,7.83.42,3.19,3.19,0,0,1,9,1.57a3.11,3.11,0,0,1,.42,1.58A3,3,0,0,1,9,4.71,3.14,3.14,0,0,1,7.83,5.84,3,3,0,0,1,6.27,6.26Z"/>
    </SVG>
  )
};

const Mail = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 16.64 13.36">
      <path
        d="M1.64,1.68H15L8.32,5.86Zm0,10V3.36L8.32,7.5,15,3.36v8.32ZM1.64,0A1.57,1.57,0,0,0,.48.5,1.65,1.65,0,0,0,0,1.68v10a1.65,1.65,0,0,0,.48,1.18,1.57,1.57,0,0,0,1.16.5H15a1.57,1.57,0,0,0,1.16-.5,1.65,1.65,0,0,0,.48-1.18v-10A1.65,1.65,0,0,0,16.16.5,1.57,1.57,0,0,0,15,0Z"/>
    </SVG>
  )
};

const Comment = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 11.65 11.65">
      <path
        d="M2.32,3.51V2.33h7V3.51Zm0,1.75V4.08h7V5.26ZM2.32,7V5.83h7V7Zm9-6.67A1.11,1.11,0,0,0,10.5,0H1.15A1.07,1.07,0,0,0,.34.34,1.11,1.11,0,0,0,0,1.15v7A1.15,1.15,0,0,0,.34,9a1.08,1.08,0,0,0,.81.35H9.33l2.32,2.32V1.15A1.07,1.07,0,0,0,11.31.34Z"/>
    </SVG>
  )
};

const Attachment = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 10.21 11.33">
      <path className="cls-1"
            d="M4.88,9.74a2.33,2.33,0,0,1-1,.61,2.36,2.36,0,0,1-1.21,0,2.29,2.29,0,0,1-1-.59,2.23,2.23,0,0,1-.6-1A2.52,2.52,0,0,1,1,7.5a2.39,2.39,0,0,1,.6-1.06L6.71,1.3A1.51,1.51,0,0,1,7.37.92a1.51,1.51,0,0,1,1.43.37A1.35,1.35,0,0,1,9.17,2a1.51,1.51,0,0,1,0,.76,1.57,1.57,0,0,1-.38.66L4.45,7.7A.55.55,0,0,1,4,7.88a.57.57,0,0,1-.41-.18.63.63,0,0,1-.19-.42.52.52,0,0,1,.17-.42L7.53,2.94l-.62-.62L3,6.24a1.35,1.35,0,0,0-.37.66,1.51,1.51,0,0,0,0,.76A1.57,1.57,0,0,0,3,8.32a1.37,1.37,0,0,0,.65.37,1.58,1.58,0,0,0,.75,0,1.33,1.33,0,0,0,.65-.39L9.39,4A2.34,2.34,0,0,0,10,1.72a2.15,2.15,0,0,0-.6-1A2.23,2.23,0,0,0,8.36.08a2.3,2.3,0,0,0-1.22,0,2.16,2.16,0,0,0-1.06.6L.94,5.82A3.26,3.26,0,0,0,.1,7.28,3.62,3.62,0,0,0,.1,9,3.4,3.4,0,0,0,.93,10.4a3.24,3.24,0,0,0,1.45.82,3,3,0,0,0,1.64,0,3.1,3.1,0,0,0,1.46-.85l4.73-4.73L9.6,5Z"/>
    </SVG>
  )
};

const Notification = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 13.36 16.26">
      <path id="icon" className="cls-1"
            d="M10,12.12v-5a4.4,4.4,0,0,0-.4-1.9A3.19,3.19,0,0,0,8.46,3.88a3.06,3.06,0,0,0-1.78-.52,3.06,3.06,0,0,0-1.78.52A3.19,3.19,0,0,0,3.76,5.22a4.4,4.4,0,0,0-.4,1.9v5Zm1.68-.86,1.68,1.68v.82H0v-.82l1.68-1.68V7.12a5.83,5.83,0,0,1,1-3.38,4.58,4.58,0,0,1,2.78-1.9V1.26A1.23,1.23,0,0,1,5.8.37,1.16,1.16,0,0,1,6.68,0a1.2,1.2,0,0,1,.89.37,1.2,1.2,0,0,1,.37.89v.58A4.54,4.54,0,0,1,10.7,3.76a5.81,5.81,0,0,1,1,3.36Zm-5,5a1.65,1.65,0,0,1-1.18-.48A1.57,1.57,0,0,1,5,14.62H8.36a1.57,1.57,0,0,1-.5,1.16A1.65,1.65,0,0,1,6.68,16.26Z"/>
    </SVG>
  )
};

const Clear = ({ fill, ...restProps }) => {
  return (
    <SVG style={{ fill }}
         {...restProps}
         viewBox="0 0 14 14">
      <path
        d="M14,1.41,12.59,0,7,5.59,1.41,0,0,1.41,5.59,7,0,12.59,1.41,14,7,8.41,12.59,14,14,12.59,8.41,7Z"/>
    </SVG>
  )
};

// map icons to obj to dynamically load by name
const icons = {
  Manage,
  Schedule,
  Boards,
  Reports,
  Wheel,
  Magnifier,
  ChevronDown,
  MoreVert,
  Plus,
  Person,
  Mail,
  Comment,
  Attachment,
  Notification,
  Clear,
  CircleWithPlus,
};

// set default props to some icons
Manage.defaultProps = {
  fill: '#c9ced5',
  width: 28
};

Schedule.defaultProps = {
  fill: '#c9ced5',
  width: 23
};

Boards.defaultProps = {
  fill: '#c9ced5',
  width: 23
};

Reports.defaultProps = {
  fill: '#c9ced5',
  width: 24
};

Wheel.defaultProps = {
  fill: '#c9ced5',
  width: 26
};

Magnifier.defaultProps = {
  fill: '#fff',
  width: 16
};

ChevronDown.defaultProps = {
  fill: '#c9ced5',
  width: 16
};

MoreVert.defaultProps = {
  fill: '#32325d',
  width: 4
};

Plus.defaultProps = {
  fill: '#c9ced5',
  width: 12
};

Person.defaultProps = {
  fill: '#c9ced5',
  width: 14
};

Mail.defaultProps = {
  fill: '#fff',
  width: 18
};

Comment.defaultProps = {
  fill: '#c9ced5',
  width: 12
};

Attachment.defaultProps = {
  fill: '#c9ced5',
  width: 11
};

Notification.defaultProps = {
  fill: '#fff',
  width: 14
};

Clear.defaultProps = {
  fill: '#fff',
  width: 14
};

CircleWithPlus.defaultProps = {
  fill: '#fff',
  width: 10
};

export default Icon;
